import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { createSelector } from 'reselect';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import config, { timeInterval } from '../../../../config';
import UserStore from '../../../../stores/UserStore';

const moment = extendMoment(Moment);
const reportFormatter = ReportComponent.formatter;
const reportUtils = ReportComponent.utils;

const rows = (state) => state.statistics.chart.rows;
const parameters = (state) => state.statistics.chart.parameters;

export const getData = createSelector(
    rows,
    parameters,
    (rows = [], parameters = {}) => {
        const keysMetrics = reportUtils.getKeysMetric();
        let range = getRange(parameters.from_day, parameters.to_day, parameters.group_by);
        let labels = [];
        let metricsData = {};

        range.map((item) => {
            const groupBy = getDateGroupBy(item, parameters.group_by);
            let dataItem = rows.find((item) => item.GroupBy === groupBy) || {};

            for (let i = 0; i < keysMetrics.length; i++) {
                let key = keysMetrics[i];
                if (key === 'GroupBy') continue;

                if (!(key in metricsData)) {
                    metricsData[key] = {
                        title: reportUtils.getTitleChain(key),
                        data: []
                    };
                }

                let value = +dataItem[key] || 0;
                metricsData[key].data.push(value);
            }

            labels.push(reportFormatter.format(groupBy, {metricKey: 'GroupBy', key: parameters.group_by}));
        });

        return {
            labels,
            metricsData
        };
    }
);

export const getGroupBy = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().chart;

        return timeInterval.map((item) => {
            item.title = staticNames[item.key];
            return item;
        });
    }
);

export const getDisabledGroupBy = createSelector(
    parameters,
    (parameters = {}) => {
        let list = [];
        let startDate = moment(parameters.from_day);
        let endDate = moment(parameters.to_day);

        (timeInterval || []).map((item) => {
            const count = Math.abs(endDate.diff(startDate, item.key + 's'));

            const minPts = config.chart && config.chart.minNumberPointsOnAxis || 2;
            const maxPts = config.chart && config.chart.maxNumberPointsOnAxis || 1000;

            if (count < minPts || count > maxPts) {
                list.push(item.value);
            }
        });

        return list;
    }
);

const getDateGroupBy = (date, groupBy) => {
    if (groupBy === 'Week') {
        date.startOf('isoWeek');
    } else if (groupBy === 'Month') {
        date.startOf('month');
    }

    return date.format(groupBy !== 'Hour' ? config.reportDateFormat : config.reportHourFormat);
};

const getRange = (startDate, endDate, groupBy) => {
    if (startDate && endDate) {
        groupBy = groupBy.toLowerCase() + 's';

        if (groupBy === 'hours') {
            startDate = moment(startDate).startOf('day').startOf('hour');
            endDate = moment(endDate).endOf('day').startOf('hour');
        }

        return Array.from(moment.range(startDate, endDate).reverseBy(groupBy)).reverse();
    }

    return [];
};
